// Base widths for images of various aspect ratios
// These can be adjusted as desired, however are mostly
// just a hint for the algorithm of the relative sizes of
// images of various aspect ratios.
export const imageRatioToWidth = ({ ratio }) => {
    if (ratio === 1) {
        // square
        return {
            width: 250
        };
    } else if (ratio < 1) {
        // portrait
        return {
            width: 200
        };
    }
    // landscape
    return {
        width: 350
    };
};
